import React, { FC, HTMLProps } from 'react';
import styles from './entities_card_footer.module.scss';
import { AnimatedLink } from '../animated-link/AnimatedLink';

type Props = HTMLProps<HTMLAnchorElement>;

export const EntitiesCardFooter: FC<Props> = props => (
  <EntitiesCardFooterContainer>
    <AnimatedLink {...props} />
  </EntitiesCardFooterContainer>
);

export const EntitiesCardFooterContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
